import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";

// Plan 2026-10-20 (B4): Zaehlweise je Grundartikel — wie viele Stueck ein Lieferanten-„Set"
// ergibt. Lesen mit article_purchase, Aendern zusaetzlich mit article_purchase_prices.

export type ZaehlweiseCode =
  | "einzelstueck"
  | "paar_2_schiene"
  | "paar_1_rollenschiene"
  | "paar_1_pendel_scharnier"
  | "set4_1_haarnadel"
  | "set_n";

/** Reihenfolge und Texte wie im Server (`zaehlweise.ts`). `stueck: null` = Zahl frei (set_n). */
export const ZAEHLWEISEN: ReadonlyArray<{ code: ZaehlweiseCode; anzeige: string; stueck: number | null }> = [
  { code: "einzelstueck", anzeige: "Einzelstück", stueck: 1 },
  { code: "paar_2_schiene", anzeige: "Paar = 2 Stück (Schiene)", stueck: 2 },
  { code: "paar_1_rollenschiene", anzeige: "Paar = 1 Stück (verbunden: Rollenschiene)", stueck: 1 },
  { code: "paar_1_pendel_scharnier", anzeige: "Paar/Set = 1 Stück (Pendelband, Pendel, Scharnier)", stueck: 1 },
  { code: "set4_1_haarnadel", anzeige: "4er-Set = 1 Stück (Haarnadel)", stueck: 1 },
  { code: "set_n", anzeige: "Set = N Stück", stueck: null },
];

export const SET_N_MIN = 2;
export const SET_N_MAX = 1000;
export const ZAEHLHINWEIS_MAX = 500;

export interface ZaehlweiseAntwort {
  stock_item_id: number;
  zaehlweise: ZaehlweiseCode | null;
  anzeige: string | null;
  stueck_je_set: number | null;
  zaehlhinweis: string | null;
  quelle: string | null;
  geaendert_von: string | null;
  geaendert_am: string | null;
}

/** Kurzform an Beleg- und WE-Zeilen; fehlt auf aelteren Server-Staenden. */
export interface ZaehlweiseKurz {
  code: ZaehlweiseCode;
  anzeige: string;
  stueck_je_set: number;
  hinweis: string | null;
}

export interface ZaehlweiseBody {
  zaehlweise: ZaehlweiseCode | null;
  stueck_je_set?: number | null;
  zaehlhinweis?: string | null;
}

export function useZaehlweise(stockItemId: number | undefined) {
  return useQuery({
    queryKey: ["zaehlweise", stockItemId],
    queryFn: () => api.get<ZaehlweiseAntwort>(`/purchase/grundartikel/${stockItemId}/zaehlweise/`),
    enabled: typeof stockItemId === "number",
    retry: false,
  });
}

export function useSetZaehlweise(stockItemId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ZaehlweiseBody) =>
      api.put<ZaehlweiseAntwort>(`/purchase/grundartikel/${stockItemId}/zaehlweise/`, body),
    onSuccess: (antwort) => {
      qc.setQueryData(["zaehlweise", stockItemId], antwort);
    },
  });
}
